// utils/featureFlags.js

// Function to check if a feature should be loaded
export const isFeatureEnabled = (feature) => {
  const envVariable = `REACT_APP_ENABLE_${feature.toUpperCase()}`;
  return process.env[envVariable] === "true";
};
